import React from "react";
import { Button } from "../../components/haven-design";

declare namespace Calendly {
  export var showPopupWidget: (url: string) => void;
}

type Props = {
  buttonText: React.ReactNode;
  url: string;
  options?: string;
}

const loadCalendly = () => {
  const head = document.querySelector("head");
  const script = document.createElement("script");
  script.setAttribute("src", "https://assets.calendly.com/assets/external/widget.js");
  script.setAttribute("id", "calendly-js");
  if (head) {
    head.appendChild(script);
  }
  return removeCalendly;
};

const removeCalendly = () => {
  const script = document.getElementById("calendly-js");
  if (script) {
    if (script.parentElement) {
      script.parentElement.removeChild(script);
    }
  }
};

const CalendlyPopup: React.FC<Props> = props => {
  React.useEffect(loadCalendly, []);
  const url = `${props.url}?${props.options}`;

  return (
    <Button
      size="L"
      color="primary"
      onClick={e => {
        e.preventDefault();
        Calendly.showPopupWidget(url);
      }}
    >
      {props.buttonText}
    </Button>
  );
};

export default CalendlyPopup;
